// Shared constants for Activity Grid and Gantt Timeline alignment
// These values MUST be identical in both components for proper row alignment

// Row heights
export const ROW_HEIGHT = 32;           // Activity row height (h-8 = 32px)
export const WBS_ROW_HEIGHT = 32;       // Regular WBS row height
export const WBS_ROW_HEIGHT_TOP = 36;   // Top-level WBS row height (slightly taller for visual hierarchy)
export const HEADER_HEIGHT = 42;        // Column header height (increased for better alignment)

// Grid/Gantt synchronization
export const SCROLL_SYNC_DELAY = 10;    // ms delay for scroll sync to prevent loops
